import {
  PLYWOOD_HISTORY_FAILED,
  PLYWOOD_HISTORY_REQUEST,
  PLYWOOD_HISTORY_SUCCESS,
} from "../../actions/Inventory/plywood/constants";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const plywoodHistoryReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case PLYWOOD_HISTORY_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case PLYWOOD_HISTORY_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case PLYWOOD_HISTORY_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
